<template>
  <div class="d-flex col w-100 justify-content-end">
    <p v-for="color in colors" :key="color.name" :class="`task task-${color.state}`">
      <span>{{ color.name }}</span>
    </p>
  </div>
</template>

<script>
  export default {
    props: {
      colors:{
        type: [Object, Array],
        default: () => {}
      }
    }
  }
</script>

<style lang="scss" scoped>
  .task {
    position: relative;
    margin-left: 4rem;
    &:before {
      content: '';
      display: block;
      position: absolute;
      left: -16px;
      top: 7px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
    &-pending:before,
    &-disconnected:before {
      background: $pending;
      border: 1px solid $border-pending;
    }
    &-processing:before {
      background: $processing;
    }
    &-dialing:before {
      background: $dialing;
    }
    &-connected:before {
      background: $connected;
    }
    &-active:before {
      background: $active;
    }
    &-checking:before {
      background: $active;
    }
  }
</style>
